export default __webpack_public_path__ + "static/media/waiting.7296d42e.svg";